import { useParams } from "react-router-dom";
import VideoImg from "assets/images/videoPoster.png";
import { useEffect, useRef } from "react";

export const VideoScreen = () => {
  const { url } = useParams();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const timeoutId = setTimeout(() => {
      if (document.fullscreenElement) return;
      video.requestFullscreen();
    }, 50);

    return () => clearTimeout(timeoutId);
  }, []);

  const getUrl = () => {
    let decodedUrl = decodeURIComponent(url);

    if (decodedUrl.endsWith(";")) {
      decodedUrl = decodedUrl.slice(0, -1);
    }

    if (decodedUrl.includes("youtu.be") || decodedUrl.includes("youtube.com")) {
      const videoId = decodedUrl.split("/").pop()?.split("?")[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
    }

    if (decodedUrl.includes("vimeo.com")) {
      const videoId = decodedUrl.split("/").pop()?.split("?")[0];
      return `https://player.vimeo.com/video/${videoId}?h=37b19e0ba5&title=0&byline=0&portrait=0&autoplay=1&loop=1&muted=1`;
    }

    return decodedUrl;
  };

  return url.includes("youtu.be") || url.includes("vimeo.com") ? (
    <iframe
      style={{ width: "100%", height: "100dvh" }}
      src={getUrl()}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen></iframe>
  ) : (
    <video
      ref={videoRef}
      poster={VideoImg}
      controls
      className="video-education-desktop"
      style={{
        width: "90%",
        height: "90%",
        borderRadius: 20,
        margin: "0 auto",
        display: "flex",
        paddingTop: "10px"
      }}
      autoPlay
      controlsList="nodownload">
      <source src={getUrl()} type="video/mp4"></source>
    </video>
  );
};
